import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useAssetsClearModel } from "../assetsClearModel";

export function ManageAssetsClear() {
    const { selectedRowKeys } = useAssetsClearModel();
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    );
}